<template>
  <div class="payment-page">
    <div class="header">Payment</div>
    <div class="main-container">
      <div class="top-container">
        <div class="title">Billing Information</div>
        <div class="title-2">Credit Card Information</div>
        <div class="card-info-container">
          <div class="card-container" v-if="!isEdit">
            {{ user.creditCard }}
          </div>
          <div class="card-container" v-if="isEdit">
            <card
              style="width: 100%"
              :class="{ complete }"
              :stripe="stripe.publishableKey"
              :options="stripe.options"
              @change="complete = $event.complete"
            ></card>
          </div>
          <hi-button class="edit-btn" @click="edit" v-if="!isEdit">{{
            $t("common.edit")
          }}</hi-button>
          <hi-button class="edit-btn" @click="save" v-if="isEdit">{{
            $t("common.save")
          }}</hi-button>
          <hi-button class="edit-btn" @click="cancel" v-if="isEdit">{{
            $t("common.cancel")
          }}</hi-button>
        </div>
        <div class="title-2" style="margin-top: 30px">Receipt Email</div>
        <div class="mail-des">{{ user.email }}</div>
      </div>
      <div class="title" style="margin-top: 30px">Payment History</div>
      <el-table class="table" :data="list">
        <el-table-column label="Status" min-width="500" prop="title">
        </el-table-column>
        <el-table-column label="Date" prop="date" min-width="180">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { Card } from "vue-stripe-elements-plus";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import HiButton from "../../components/button/Index.vue";
import { updateCard, history } from "../../service/payment";
import { updateUserInfo } from "../../service/user";
import { showErrorMsg } from "../../utils/errors";

export default {
  name: "PaymentPage",
  components: { Card, HiButton },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
  },
  data() {
    return {
      stripe: {
        publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
        options: {
          hidePostalCode: true,
        },
      },
      complete: false,
      isEdit: false,
      list: [],
    };
  },
  methods: {
    /**
     * 编辑按钮点击事件
     */
    async save() {
      const loading = this.$loading();
      try {
        await updateCard();
        await updateUserInfo({ withStripe: true });
        this.isEdit = false;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 取消按钮
     */
    async cancel() {
      this.isEdit = false;
    },
    /**
     * 编辑按钮点击事件
     */
    async edit() {
      this.isEdit = true;
    },
  },
  async created() {
    const loading = this.$loading();
    try {
      await updateUserInfo({ withStripe: true });
      this.list = await history({ offset: this.offset });
    } catch (e) {
      showErrorMsg(e);
    } finally {
      loading.close();
    }
  },
};
</script>
<style lang="less">
.payment-page {
  .el-table td,
  .el-table th {
    padding: 20px 20px 20px 0 !important;
  }
}
</style>
<style scoped lang="less">
@import "../../assets/style/theme.less";

.payment-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .header {
    height: 80px;
    padding: 0 60px;
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 20px;
    border-bottom: 1px solid #eceff1;
  }
  .title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 30px;
  }
  .title-2 {
    font-size: 16px;
    font-weight: 500;
  }
  .main-container {
    flex: 1;
    overflow: auto;
    padding: 50px 60px;
    .top-container {
      border-bottom: 1px solid @border-color;
      padding-bottom: 30px;
      .card-info-container {
        display: flex;
        align-items: center;
        margin-top: 14px;
        .card-container {
          height: 43px;
          border: 1px solid @border-color;
          background: #f5f5f7;
          border-radius: 4px;
          padding: 0 12px;
          display: flex;
          align-items: center;
          width: 400px;
          .stripe-card {
            width: 100%;
          }
        }
        .edit-btn {
          margin-left: 14px;
        }
      }
      .mail-des {
        margin-top: 15px;
        font-size: 16px;
      }
    }
  }
}
</style>
